import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@/app/store';
import { ChatView } from '@/features/chat/ChatView';

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <div className="min-h-screen bg-secondary-50">
        <Routes>
          <Route path="/" element={<ChatView />} />
        </Routes>
      </div>
    </BrowserRouter>
  </Provider>
);

export default App;